import { render, staticRenderFns } from "./editParent.vue?vue&type=template&id=468606e4&scoped=true&"
import script from "./editParent.vue?vue&type=script&lang=js&"
export * from "./editParent.vue?vue&type=script&lang=js&"
import style0 from "./editParent.vue?vue&type=style&index=0&id=468606e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468606e4",
  null
  
)

export default component.exports